import { Sparkles } from 'lucide-react';
import AIChat from '../components/AIChat';
import { useAuth } from '../lib/auth';

export default function AIAssistantPage() {
  const { user } = useAuth();
  const isStaff = user?.type === 'staff';

  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <Sparkles className="text-purple-400" size={20} />
        <h1 className="text-2xl font-bold text-white">AI-ассистент</h1>
        <span className="text-xs text-slate-500">VALO Cloud · RAG-документация</span>
      </div>
      <AIChat
        title="Спросите ассистента"
        subtitle={isStaff
          ? "Помощник работает с полной документацией valo-ai (RAG). Используйте, когда нужно быстро найти команду, файл конфига или известный кейс — но проверяйте ответ перед отправкой клиенту."
          : "Помощник отвечает на вопросы про VALO Cloud на основе документации. Если в документации нет ответа — создайте тикет в Service Desk."
        }
        storageKey="ai-chat.global"
      />
    </div>
  );
}
